import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, useTheme } from '@mui/material'
import React from 'react'

const SummaryTable = (props) => {
    const { id, columnSummaryDefs, reportData } = props
    const theme = useTheme()
    const { tableHeaderColor } = theme
    return (
        <TableContainer component={Paper} className='scroll' sx={{
            maxWidth: '965px', maxHeight: '50vh', marginBottom: "5px"
        }} >
            <Table id={id} stickyHeader size="small" aria-label="a dense table">
                <TableHead>
                    <TableRow style={{ border: 'none' }}>
                        {columnSummaryDefs.map((col, index) =>
                            <TableCell key={`TH-${index}`} colSpan={col.colSpan} sx={{ ...col.headerSx, whiteSpace: 'nowrap', backgroundColor: tableHeaderColor?.isHeadingColor, fontSize: '12px', fontWeight: '600',color: '#444' }}><span style={{ borderBottom: col.borderBottom, display: 'block' }}>{col.headerName}</span></TableCell>
                        )}
                    </TableRow>
                </TableHead>
                <TableBody sx={{ overflow: 'scroll', height: '100%' }}>
                    {reportData.map((row, index) => {
                        return row.isRowData ? <TableRow key={`DR-${index}`}>
                            <TableCell sx={{fontWeight:'500',color: '#444', textAlign: 'left', fontSize: '12px' }}>{row.StateAsPerGSTNNo}</TableCell>
                            <TableCell sx={{fontWeight:'500',color: '#444', textAlign: 'right', fontSize: '12px' }}>{row.Rate}</TableCell>
                            <TableCell sx={{fontWeight:'500',color: '#444', textAlign: 'right', fontSize: '12px' }}>{row.TaxableValue}</TableCell>
                            <TableCell sx={{fontWeight:'500',color: '#444', textAlign: 'right', fontSize: '12px' }}>{row.IGST}</TableCell>
                            <TableCell sx={{fontWeight:'500',color: '#444', textAlign: 'right', fontSize: '12px' }}>{row.CGST}</TableCell>
                            <TableCell sx={{fontWeight:'500',color: '#444', textAlign: 'right', fontSize: '12px' }}>{row.SGST}</TableCell>
                        </TableRow> : row.isNoData ?
                            <TableRow>
                                <TableCell colSpan={row.colSpan} align='center' sx={{ minHeight: '36px', fontSize: '12px',fontWeight:'500',color: '#444' }}>{row.caption}</TableCell>
                            </TableRow> : null
                    })}
                </TableBody>
            </Table>
        </TableContainer>
    )
}

export default SummaryTable